import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    navbarRoute,
    mentionLegaleRoute,
    conditionGeneraleRoute,
    changelogRoute,
    accessibiliteRoute,
    personalDataRoute
} from '../app.route';
import { errorRoute } from './error/error.route';
import { planSiteRoute } from './footer/plan-site/plan-site.route';

let LAYOUT_ROUTES = [
    navbarRoute,
    mentionLegaleRoute,
    conditionGeneraleRoute,
    accessibiliteRoute,
    personalDataRoute,
    planSiteRoute,
    changelogRoute,
    ...errorRoute
];

@NgModule({
  imports: [
    RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
  ],
  exports: [
    RouterModule
  ]
})
export class LayoutRoutingModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/layout-routing.module.ts